import { MagnifyingGlassIcon } from '@radix-ui/react-icons';
import { Link, useParams } from '@tanstack/react-router';
import { EmptyState } from '@/components/states';
import { Button } from '@/components/ui/button';

export function RoundNotFound() {
  const { roundId } = useParams({ strict: false });
  return (
    <EmptyState
      icon={<MagnifyingGlassIcon />}
      title="Round not found"
      description={
        roundId ? `There's no round ${roundId} you can see. Check the id, or search the rounds list.` : undefined
      }
      action={
        <Button variant="outline" asChild>
          <Link to="/rounds">Back to rounds</Link>
        </Button>
      }
    />
  );
}
